import {useMemo} from 'react'

import {useSubscription} from '../../../api/subscriptions/hooks'

export const useSubscriptionPaymentOptions = (subscriptionId: string) => {
  const {data: subscription} = useSubscription(subscriptionId)
  return useMemo(() => {
    if (!subscription) {
      return []
    }
    return subscription.prices
  }, [subscription])
}